<template>
  <div id="_user_phone_number_factor" class="q-px-md">
    <div class="q-mt-xl q-py-md">
      当前账号尚未绑定手机号，您必须绑定手机号以登录系统，绑定的手机号可用于登录和密码找回
    </div>

    <section class="row no-wrap items-start q-mb-md ">
      <q-input
        class="col-7"
        type="text"
        v-model="phoneNumberInput"
        filled
        dense
        @input="checkPhoneNumberInput"
        :error="!!phoneNumberInputErrorMsg"
        :error-message="phoneNumberInputErrorMsg"
        no-error-icon
        maxlength="11"
        counter
      />
      <q-btn
        style="height: 40px"
        class="col-5 q-ml-xs col-shrink"
        outline
        color="primary"
        @click="sendVericationCode"
        :disable="
          !phoneNumberInput ||
            verificationCodeWait > 0 ||
            !!phoneNumberInputErrorMsg
        "
      >
        <span v-if="verificationCodeWait === 0">获取验证码</span>
        <span v-else>{{ verificationCodeWait }} 秒后重试</span>
      </q-btn>
    </section>
    <section v-if="phoneNumberSentCode && bizId">
      <div>
        <span>验证码已发送到</span>
        <span class="text-primary text-bold">
          {{ phoneNumberSentCode }}
        </span>
        <span>请注意查收，该验证码3分钟内有效</span>
      </div>
      <CheckCodeInput
        v-model="verificationCode"
        type="text"
        highLightColor="var(--q-color-primary)"
        :margin="2"
        class="q-my-md"
      />
    </section>

    <q-btn
      :disable="notReadyToCommit"
      flat
      style="height: 40px"
      class="bg-primary text-white full-width"
      @click="bindPhoneNumber"
    >
      确认
    </q-btn>
  </div>
</template>

<script>
import AuthFormatMixin from "./format.mixin";
import { sendVerificationCode } from "../../api/endpoints/sms/sendVerificationCode";
import { bindMobile } from "../../api/endpoints/auth/bindMobile";
import AuthMixin from "./auth.mixin";

export default {
  mixins: [AuthFormatMixin, AuthMixin],
  components: {
    CheckCodeInput: () => import("@/components/CheckcodeInput"),
  },
  data() {
    return {
      phoneNumberInput: "", // 输入框中的手机号
      phoneNumberSentCode: "", // 已发送验证码的手机号
      phoneNumberInputErrorMsg: "", // 手机号输入的错误信息
      verificationCode: "", // 输入框中输入的验证码
      bizId: "", // 短信服务的短信标识

      verificationCodeWait: 0,
      codeWaitInterval: null,
    };
  },

  computed: {
    notReadyToCommit() {
      const { phoneNumberSentCode, bizId, verificationCode } = this;
      return !(phoneNumberSentCode && bizId && verificationCode.length === 6);
    },
  },

  methods: {
    checkPhoneNumberInput(value) {
      const legal = this.checkPhoneNumber(value);
      this.phoneNumberInputErrorMsg = legal ? "" : "手机号格式有误";
    },

    /**
     * 请求发送验证码到手机
     */
    async sendVericationCode() {
      this.verificationCodeWait = 60;
      this.codeWaitInterval = setInterval(() => {
        this.verificationCodeWait--;
        if (this.verificationCodeWait === 0) {
          clearInterval(this.codeWaitInterval);
        }
      }, 1000);
      const { phoneNumberInput } = this;
      this.phoneNumberSentCode = phoneNumberInput;
      this.bizId = "";
      try {
        const response = await sendVerificationCode({
          phoneNumber: this.phoneNumberSentCode,
          action: "bind",
        });
        if (response.BizId) {
          this.bizId = response.BizId;
        } else if (response.error) {
          this.$q.notify({
            type: "danger",
            message: response.message,
          });
        } else {
          throw Error(response);
        }
      } catch (err) {
        console.log(err);
        this.$q.notify({
          type: "danger",
          message: "发送验证码时出现未知错误",
        });
      } finally {
        if (!this.bizId) {
          clearInterval(this.codeWaitInterval);
          this.codeWaitInterval = null;
          this.verificationCodeWait = 0;
        }
      }
    },

    /**
     * 绑定手机号
     */
    async bindPhoneNumber() {
      try {
        const response = await bindMobile({
          phoneNumber: this.phoneNumberSentCode,
          code: this.verificationCode,
          bizId: this.bizId,
        });
        console.log(response);

        if (response.status || response.error) {
          this.$q.notfiy({
            type: "danger",
            message: response.detail || response.message,
          });
        } else {
          this.$q.notify({
            type: "success",
            message: response.detail || response.message,
          });
          this.resolveUserStatus();
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
